import fetchJSON from '@api/api_helper';
import merge from 'deepmerge';

const getUrl = (attachmentKey) => `/api/v4/attachments/${attachmentKey}`;

export const get = (attachmentKey, options) => {
  // Resource context relevant for watermark_resources feature
  const resourceContext = {
    params: {
      manifest_digest: BFG.manifestDigest ?? null,
      resource_type: BFG.resource.type ?? null,
      resource_key: BFG.resource.key ?? null,
    }
  };
  const allOptions = merge(options, resourceContext);
  return fetchJSON(getUrl(attachmentKey), allOptions)
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); });
};

const updateAttachment = (options) => {
  const url = getUrl(options.attachmentKey);
  const appendedOptions = {
    method: 'PUT',
    body: { data: options.data },
    context: options.context
  };

  return fetchJSON(url, appendedOptions);
};

export const deleteAttachment = (attachmentKey) => {
  const url = getUrl(attachmentKey);
  const appendedOptions = {
    method: 'DELETE'
  };

  return fetchJSON(url, appendedOptions);
};

export default updateAttachment;
